import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=e8f7394a&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=e8f7394a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8f7394a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8f7394a')) {
      api.createRecord('e8f7394a', component.options)
    } else {
      api.reload('e8f7394a', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=e8f7394a&scoped=true&", function () {
      api.rerender('e8f7394a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-230n7phGQOPEg/JS/comp/GuestBox.vue"
export default component.exports